import { useLazyQuery, useMutation } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Button, Form, Spinner, Modal, Alert, ButtonGroup, SplitButton, Dropdown, Row, Col } from "react-bootstrap";
import { COLOR_APP, COLOR_TEXT, COLOR_TOMATO, COLOR_WHITE, LINEAR_GRADIENT_BG, RemoveFields, S3_URL } from "../../../constants";
import { GET_BANKS } from "../../../graphql/bank/query";
import { imageRender } from "../../../helpers";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import _ from "lodash";
import {
  faCopy,
  faFileArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import { useToasts } from "react-toast-notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { GET_PRESIGN_URL } from "../../../graphql/presignUrl/query";
import { CONFIRM_ORDER_GROUP, UPDATE_ORDERGROUP } from "../../../graphql/order/mutation";
import { GET_USER_CONFIRMS } from "../../../graphql/userConfirm/query";
import UserVerifyIdentity from "../../users/UserVerifyIdentity";
import ReceiveDeliveryAddress from "../../settings/settingLogictics/settingReceive/CardDefaultReceiveAddress";
import FormReceiveAddress from "../../settings/settingLogictics/settingReceive/FormReceiveAddress";
import { GET_MANY_USER_ADDRESS_USER_ID } from "../../../graphql/userConfirm/userAddress/query";
import { ADD_ORDER_DELIVERY } from "../../../graphql/orderDelivery/mutation";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { requestionFields } from "../../../helpers/sweetalert";

const ShopInfoOrderConfirm = ({
  orderData,
  setLastStep,
  // setSecondStep,
  // shopSettingData,
  // bankData,
  isUseLogicstics,
  setIsUseLogicstics,
  setIsuse,
  isAlert,
  setIsAlert,
  isModalVerifyIdentity,
  setIsModalVerifyIdentity,
  setIsShipMentPayType,
  isShipMentPayType,
  settingDataByShop,
  shopRate
}) => {
  const { addToast } = useToasts();

  const [getPresignUrl, { data: presignUrlData }] = useLazyQuery(GET_PRESIGN_URL);
  const [getUserConfirms, { data: userConfirmDatas }] = useLazyQuery(GET_USER_CONFIRMS);
  const [loadBankAccount, { data: bankAccountData }] = useLazyQuery(GET_BANKS, {
    fetchPolicy: "cache-and-network",
  });


  // const [updateOrderGroup, { loading: updateOrderGroupLoading }] = useMutation(UPDATE_ORDERGROUP);
  const [confirmOrderGroup, { loading: confirmOrderGroupLoading }] = useMutation(CONFIRM_ORDER_GROUP);

  // State
  // const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState({});
  const [file, setFile] = useState();
  const [paySlip, setPaySlip] = useState();
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [customerName, setCustomerName] = useState("");
  // const [bankQr, setBankQr] = useState();
  const [defaultBank, setDefaultBank] = useState();
  const [bankAccountLists, setBankAccountLists] = useState([])

  useEffect(() => {
    if (orderData) {
      setCustomerName(orderData?.customerName || orderData?.cfName);
      setAddress(`${orderData?.logistic || ""} ${orderData?.addressCf || ""}`);
      if(orderData?.phone !== "" && orderData?.phone !== "-") setPhone(orderData?.phone);
      
      if (!_.isEmpty(orderData?.userFbId) && !orderData?.customerName && !orderData?.cfName
        && !orderData?.addressCf && !orderData?.phone) {
        getUserConfirms({
          variables: {
            where: {
              psid: orderData?.userFbId
              // name: orderData?.cfName
            },
            orderBy: "createdAt_DESC"
          },
        });
      }

      loadBankAccount({
        variables: {
          where: {
            shop: orderData?.shop?.id,
            isDeleted: false,
          }
        }
      })
    }

  }, [orderData]);

  useEffect(() => {
    if (bankAccountData) {
      setBankAccountLists(bankAccountData?.banks?.data)
      const _bankActive = bankAccountData?.banks?.data.find((data) => data?.isActiveDefault || data[0]);

      if (_bankActive) {
        setSelectedBank(_bankActive);
      }
    }
  }, [bankAccountData])

  useEffect(() => {
    if (userConfirmDatas?.userConfirms?.data) {

      setPhone(userConfirmDatas?.userConfirms?.data[0]?.phone);
      setAddress(userConfirmDatas?.userConfirms?.data[0]?.addressCF)
    }
  }, [userConfirmDatas])

  // useEffect(() => {
  //   if (shopSettingData?.settings?.data) {
  //     setBankQr(shopSettingData?.settings?.data[0]?.bankQr);
  //     let _bank = JSON.parse(shopSettingData?.settings?.data[0]?.bank);
  //     setDefaultBank(_bank);
  //   }

  //   if (bankData?.banks) {
  //     // filter active bank
  //     const _bankActive = bankData?.banks?.data.find((data) => data?.isActiveDefault); // Using `find` to get the first matching bank

  //     if (_bankActive) {
  //       setSelectedBank(_bankActive); // Set the selected bank
  //     } else {
  //       setSelectedBank(bankData?.banks?.data[0]); // Set the selected bank

  //     }
  //     setBanks(bankData?.banks?.data); // Set all banks
  //   }
  // }, [bankData, shopSettingData]);

  useEffect(() => {
    if (presignUrlData?.preSignedUrl?.url) {
      onFileUpload(presignUrlData?.preSignedUrl?.url);
    }
  }, [presignUrlData]);

  const onFileUpload = async (url) => {
    try {
      if (file && url) {
        await axios.put(url, file, {
          headers: {
            "Content-Type": "file/*; image/*",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        });
        // console.log("uploadfile: ", uploadfile);
      }
    } catch (error) {
      setPaySlip(null);
      setFile(null);
      console.log("ERROR: ", error);
      return requestionFields({
        text: "ກະລຸນາອັບໂຫຼດສະລີບໂອນເງິນຄືນຫມ່ອີກຄັ້ງ",
      })
    }
  };

  const onCopy = (bankAccount) => {
    navigator.clipboard.writeText(bankAccount ?? "");
    addToast(`Copy ເລກບັນຊີແລ້ວ`, {
      appearance: "success",
      autoDismiss: true,
    });
  };

  const handleUpload = async (event) => {
    try {
      setFile(event.target.files[0]);
      var ext = event.target.files[0].name.split(".").pop();
      let filename = uuidv4() + "." + ext;
      await getPresignUrl({ variables: { name: filename } });
      // console.log("filename: ", filename)
      setPaySlip(filename);
    } catch (error) {
      console.log(error);
    }
  };

  const ImageThumb = ({ image }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        style={{
          borderRadius: "3",
          height: "80vw",
          width: "80vw",
        }}
      />
    );
  };

  //! USER VERIFY_IDENTITY
  const [isVerifyIdentity, setIsVerifyIdentity] = useState(false);
  const [idDataUserConfirm, setIdDataUserConfirm] = useState({});
  const onCloseModalVerifyIdentity = () => setIsModalVerifyIdentity(false);
  useEffect(() => {
    if (!isVerifyIdentity) {
      if (isVerifyIdentity) onCloseModalVerifyIdentity();
    }
  }, [isVerifyIdentity]);

  //! RECEIVE ADDRESS
  const [isReceiveData, setIsReceiveData] = useState({});
  const [isAddModal, setIsAddModal] = useState(false);
  const onCloseModalAdd = () => setIsAddModal(false);
  const [userAddressUserId_API, { data: userAddressUserId_DATA }] =
    useLazyQuery(GET_MANY_USER_ADDRESS_USER_ID, {
      fetchPolicy: "cache-and-network",
    });

  useEffect(() => {
    if (!_.isEmpty(isReceiveData)) {
      setCustomerName(isReceiveData?.userName);
      setAddress(isReceiveData?.address);
      setPhone(isReceiveData?.userTel);
    }
  }, [isReceiveData]);

  useEffect(() => {
    // GET User Address By User ID
    if (!_.isEmpty(idDataUserConfirm)) {
      fetchUserAddressUserId_API();
    }
  }, [idDataUserConfirm]);

  const fetchUserAddressUserId_API = async () => {
    try {
      await userAddressUserId_API({
        variables: {
          where: {
            user: idDataUserConfirm?.id
          },
        },
      });
    } catch (err) {
      console.log("ERROR_fetchUserAddressUserId_API")
    }
  };

  //! ADD_USER_ADDRESS
  const [addOrderDelivery_API, { loading: addOrderDeliveryLoading }] = useMutation(ADD_ORDER_DELIVERY);
  const addOrderDeliveryWeb = async (_dataShipMentPay) => {
    try {
      let _data = {
        // shipment_pay_type: orderData?.orders[0]?.stock?.shipment_pay_type ?? "CDC",
        shipment_pay_type: !_.isEmpty(_dataShipMentPay) ? "COD" : "CDC",
        latLong: isReceiveData?.latLong,
        sender: isReceiveData?.sender,
      }

      const newAddOrderDelivery_API = await addOrderDelivery_API({
        variables: {
          data: _data,
          where: {
            delivery: isReceiveData?.deliveryName,
            orderGroupId: orderData?.id,
            userAddressId: isReceiveData?.id,
            shop: orderData?.shop?.id
          }
        }
      });
      if (newAddOrderDelivery_API?.data?.addOrderDelivery?.message !== "Success") throw newAddOrderDelivery_API?.data?.addOrderDelivery?.message;
      return { isError: false };
    } catch (err) {
      addToast("ສ້າງຂົນສົ່ງບໍ່ສຳເລັດ", {
        appearance: "error",
        autoDismiss: true,
      });
      console.log("ERROR_addOrderDeliveryWeb");
      return { isError: true };
    }
  }

  useEffect(() => {
    if (isShipMentPayType?.data) {
      _updateOrderGroup(isShipMentPayType?.data)
    }
  }, [isShipMentPayType?.data])

  //TODO Confirm order
  const _updateOrderGroup = async (dataShipMentPay) => {
    try {
      // if (updateOrderGroupLoading) return;
      if (confirmOrderGroupLoading) return;

      if (_.isEmpty(customerName)){
        return requestionFields({
          text: "ກະລຸນາປ້ອນຊື່ກ່ອນ",
        });
      }
      if (_.isEmpty(phone)){
        return requestionFields({
          text: "ກະລຸນາປ້ອນເບີໂທກ່ອນ",
        });
      }
      if (phone.length < 7 || phone.length > 11){
        return requestionFields({
          text: "ກະລຸນາປ້ອນເບີໂທ 7-8 ໂຕເລກ ໂດຍບໍ່ຕ້ອງໃສ່ 020 ຂື້ນຕົ້ນ",
        });
      }

      if (address === "" || address === null || address === undefined || address === " "){
        return requestionFields({
          text: "ກະລຸນາປ້ອນທີ່ຢູ່ກ່ອນ",
        });
      }
      if (_.isEmpty(dataShipMentPay)){
        if (_.isEmpty(paySlip)) {
            return requestionFields({
              text: "ກະລຸນາອັບໂຫຼດສະລີບໂອນເງິນກ່ອນ",
            })
        }
      }

      //! RECEIVE
      if (isUseLogicstics === "IS_USE_LOGICSTIC") {
        const newAddOrderDelivery = await addOrderDeliveryWeb(dataShipMentPay);
        if (newAddOrderDelivery && newAddOrderDelivery.isError) throw "ERROR_CREATE_DELIVERY";
      }

      let _dataOrderGroup = {
        paySlip: paySlip,
        customerName: customerName,
        phone: phone,
        addressCf: address,
        isPaymented: true,
        paymentType: "DESTINATION",
        payment: "TRANSFER",
        bank: selectedBank?.id,
        status: "WAITINGCONFIRM",
        paymentMethod: "MANNUALY"
      }

      if(orderData.sumPriceBaht > 0 || orderData.sumPriceUsd > 0){
        const newRate = RemoveFields(shopRate, ["__typename"]);
        _dataOrderGroup = {
          ..._dataOrderGroup,
          rate: JSON.stringify(newRate)
        }
      }

      if (!_.isEmpty(dataShipMentPay)) {
        _dataOrderGroup = {
          ..._dataOrderGroup,
          dataConfirmCod: JSON.stringify(dataShipMentPay)
        }
      }


      // const res = await updateOrderGroup({
      //   variables: {
      //     data: _dataOrderGroup,
      //     where: {
      //       id: orderData?.id,
      //     },
      //   },
      // });
      // if (res) {
      //   setLastStep(true);
      //   addToast("ບັນທຶກສໍາເລັດ", {
      //     appearance: "success",
      //     autoDismiss: true,
      //   });
      //   window.location.reload();
      // }
      const resConfirm = await confirmOrderGroup({
        variables: {
          data: _dataOrderGroup,
          where: {
            id: orderData?.id,
            shop: orderData?.shop?.id,
          },
        },
      });
      if (resConfirm?.data?.confirmOrderGroups?.status) {
        setLastStep(true);
        addToast("ບັນທຶກສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
        window.location.reload();
      } else {
        addToast(resConfirm?.data?.confirmOrderGroups?.msg || "ບໍ່ສາມາດຢືນຢັນອໍເດີ ກະລຸນາລອງໃຫມ່ພາຍຫລັງ", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    } catch (error) {
      addToast("ເກີດຂໍ້ຜິດພາດ", {
        appearance: "error",
        autoDismiss: true,
      });
      console.log(error);
    }
  };

  // select the bank in dropdown
  const onSelectBankActive = (bank) => {
    setSelectedBank(bank)
  };



  if (addOrderDeliveryLoading) return <LoadingSpinner />;

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        margin: "10px 0",
        alignItems: "center",
      }}
    >
      {/* //! VERIFY_USER */}
      {!isVerifyIdentity && (
        <div style={{
          // border: '1px solid #E5E5E5',
          padding: '15px',
          borderRadius: '5px',
          backgroundColor: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <Modal centered show={isModalVerifyIdentity}>
            <Modal.Header>
              <Modal.Title>ຢືນຢັນຕົວຕົນ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <UserVerifyIdentity
                setDataUserConfirm={setIdDataUserConfirm}
                onCloseModalVerifyIdentity={onCloseModalVerifyIdentity}
                setIsUseLogicstics={setIsUseLogicstics}
                setIsVerifyIdentity={setIsVerifyIdentity} />
            </Modal.Body>
          </Modal>
        </div>
      )}

      <div style={{ width: "100%" }}>
        {isUseLogicstics === "IS_USE_LOGICSTIC" ? (
          <>
            {!_.isEmpty(userAddressUserId_DATA?.userAddressUserId?.data) ? (
              <ReceiveDeliveryAddress
                userAddress={userAddressUserId_DATA?.userAddressUserId?.data}
                setIsReceiveData={setIsReceiveData}
                userConfirm={!_.isEmpty(idDataUserConfirm) ? idDataUserConfirm : null}
                psid={orderData?.userFbId}
                orderGroup={orderData}
              />

            ) : (
              <div style={{
                border: '1px solid #E5E5E5',
                padding: '15px',
                borderRadius: '5px',
                backgroundColor: '#fff',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
                <Button onClick={() => setIsAddModal(true)} size='sm' variant='danger'>***** ກະລຸນາສ້າງທີ່ຢູ່ສຳລັບຂົນສົ່ງຂອງທ່ານ!. *****</Button>
                <Modal centered show={isAddModal} onHide={onCloseModalAdd}>
                  <Modal.Header closeButton>
                    <Modal.Title>ເພີ່ມທີ່ຢູ່ສຳລັບການຈັດສົ່ງ</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <FormReceiveAddress
                      userConfirm={!_.isEmpty(idDataUserConfirm) ? idDataUserConfirm : null}
                      psid={orderData?.userFbId}
                      onCloseModalAdd={onCloseModalAdd}
                      fetchUserAddressData={fetchUserAddressUserId_API}
                      orderData={orderData}
                    />
                  </Modal.Body>
                </Modal>
              </div>
            )}
          </>

        ) : (
          <div
            style={{
              background: "#fff",
              borderRadius: ".5em",
              padding: "5px 0",
            }}
          >
            {isAlert && (
              <Alert variant="danger" onClick={() => setIsAlert(false)} dismissible>
                ກາລຸນາປ້ອນ ເບີໂທ ແລະ ທີ່ຢູ່ປາຍທາງ ໃຫ້ຄົບຖ້ວນ!
              </Alert>
            )}
            <Row>
              <Col md={6} sm={12}> {/* NAME */}
                <Form.Group className="mb-3">
                  <Form.Label>
                    {'ຊື່ລູກຄ້າ'}
                    <span style={{ color: 'red', marginLeft: '1px' }}>*</span>
                  </Form.Label>
                  <Form.Control
                    value={customerName}
                    onChange={(e) => setCustomerName(e?.target?.value)}
                    type="text"
                  />
                </Form.Group>
              </Col>
              <Col md={6} sm={12}> {/* PHONE */}
                <Form.Group className="mb-3">
                  <Form.Label>
                    {'ເບີໂທ'}
                    <span style={{ color: 'red', marginLeft: '1px' }}>*</span>
                  </Form.Label>
                  <span
                    style={{
                      position: "absolute",
                      left: 0,
                      paddingTop: 14,
                      top: "1.6em"
                    }}
                  >
                    020
                  </span>
                  <Form.Control
                    style={{
                      width: "100%",
                      border: ".02em solid #ddd",
                      paddingLeft: "1.8em"
                    }}
                    value={phone}
                    onChange={(e) => {
                      const input = e.target.value;
                      // Only allow numbers and limit to 11 characters
                      const numericInput = input.replace(/\D/g, '');
                      if (numericInput.length < 12) {
                        setPhone(numericInput);
                      }
                    }}
                    // TODO: Block enter key
                    // onKeyDown={(e) => {
                    //   // Allow: backspace, delete, tab, escape, enter, and decimal point
                    //   if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
                    //       // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                    //       // (e.keyCode === 65 && e.ctrlKey === true) ||
                    //       // (e.keyCode === 67 && e.ctrlKey === true) ||
                    //       // (e.keyCode === 86 && e.ctrlKey === true) ||
                    //       // (e.keyCode === 88 && e.ctrlKey === true) ||
                    //       // Allow: home, end, left, right, down, up
                    //       (e.keyCode >= 35 && e.keyCode <= 40)) {
                    //     return;
                    //   }
                    //   // Ensure that it's a number and stop the keypress
                    //   if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                    //     e.preventDefault();
                    //   }
                    // }}
                    type="tel"
                    placeholder="xxx-xxx-xx"
                    maxLength={11}
                    isInvalid={phone && (phone.length < 7 || phone.length > 11)}
                    className={phone && phone.length >= 7 && phone.length <= 11 ? 'is-valid' : ''}
                  />
                  <Form.Control.Feedback type="invalid">
                    {phone && phone.length < 7 && "ເບີໂທຕ້ອງມີຢ່າງໜ້ອຍ 7 ໂຕເລກ"}
                    {phone && phone.length > 11 && "ເບີໂທຕ້ອງບໍ່ເກີນ 11 ໂຕເລກ"}
                  </Form.Control.Feedback>
                  <Form.Text className="text-muted">
                    ປ້ອນເບີໂທ 8 ໂຕເລກ (ບໍ່ຈຳເປັນຕ້ອງໃສ່ 20, 020, 030, ຫຼື 856)
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3"> {/* ADDRESS */}
              <Form.Label>
                {'ທີ່ຢູ່ຂົນສົ່ງ ພິມຊື່ຂົນສົ່ງ ສາຂາ ໃຫ້ລະອຽດ'}
                <span style={{ color: 'red', marginLeft: '1px' }}>*</span>
              </Form.Label>
              <Form.Control
                value={address}
                onChange={(e) => setAddress(e?.target?.value)}
                as="textarea"
                type="text"
              />
            </Form.Group>
          </div>
        )}

        {/* //* PAYMENT */}

      </div>
      <div
        style={{
          width: "100%",
          padding: "20px 0",
          background: "#FFF",
        }}
      >
        <div className="mb-1 w-100">
          <SplitButton
            id={`down-start`}
            drop="down-start"
            variant="outline-secondary"
            title={selectedBank?.bankName ? selectedBank?.bankName : "ບັນຊີທະນາຄານຂອງຮ້ານ"}
            style={{ width: '100%' }}
          >
            {bankAccountLists.map((item, index) => (
              <Dropdown.Item onClick={() => onSelectBankActive(item)} active={item?.bankUser === selectedBank?.bankUser ? true : false} key={index} eventKey={item?.bankUser}>{item?.bankName}</Dropdown.Item>
            ))}
          </SplitButton>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>ຊື່ບັນຊີ</div>
          <div style={{ fontSize: 18, fontWeight: "bold" }}>
            {selectedBank?.bankUser ?? defaultBank?.bankUser}
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>ເລກບັນຊີ</div>
          <div style={{ fontSize: 18, fontWeight: "bold" }}>
            <FontAwesomeIcon
              icon={faCopy}
              className="mr-2"
              color={COLOR_APP}
              onClick={() => onCopy(selectedBank?.bankAccount)}
            />
            {selectedBank?.bankAccount ?? defaultBank?.bankAccount}
          </div>
        </div>


      </div>
      <div
        style={{
          width: "100%",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          padding: 5,
          background: "#FFF",
          border: '1px dashed #777'
        }}
      >
      </div>
      <div
        style={{
          marginTop: '-2em',
          width: "100%",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          // padding: 5,
          background: "#FFF",
          border: '1px dashed #777',
          position: "relative",
          overflow: "hidden"
        }}
      >
        <img
          src={imageRender(selectedBank?.image)}
          style={{ alignSelf: "center", width: "100%", maxHeight: "60vh", height: '100%', objectFit: 'cover', filter: "blur(1em)" }}
        />
        <img
          src={imageRender(selectedBank?.image)}
          style={{ alignSelf: "center", width: "100%", height: '100%', objectFit: 'contain', position: "absolute", left: "50%", transform: "translateX(-50%)", }}
        />
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "100%",
          textAlign: "left",
          fontSize: 18, opacity: 0.7
        }}
      >
        {'ບ່ອນອັບໂຫຼດສະລີບໂອນເງິນ'} 
        <span style={{ color: 'red', marginLeft: '1px' }}>*</span>
      </div>
      <div style={{
        display: "flex", width: "100%", justifyContent: "center", border: '1px dashed #777'
      }}>
        <label htmlFor="file-upload" className="w-100">
          <div
            style={{
              background: "#fff",
              height: "auto",
              width: "100%",
              border: "3px dashed " + COLOR_APP,
              borderRadius: 8,
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: 'center',
              overflow: 'hidden',
              maxHeight: "25em"
            }}
          >
            <input
              type="file"
              id="file-upload"
              onChange={handleUpload}
              hidden
            />
            {file ? (
              <ImageThumb image={file} />
            ) : paySlip ? (
              <img
                alt="paments"
                src={imageRender(paySlip)}
                style={{ objectFit: "contain", width: "50%", height: "50%" }}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  height: 140,
                  width: 140,
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: 'column'
                }}
              >
                <FontAwesomeIcon icon={faFileArrowUp} style={{ fontSize: 36, }} />
                <p style={{ opacity: 0.5 }}>ອັບໂຫຼດຮູບ</p>
              </div>
            )}
          </div>
        </label>
      </div>

      <div
        style={{
          display: "flex",
          whiteSpace: "nowrap",
          width: "100%",
          padding: "8px 0"
        }}
      >

        <ButtonGroup aria-label="Basic example" className="w-100" size="lg">
          <Button
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "none",
              background: LINEAR_GRADIENT_BG,
            }}
            onClick={() => {
              _updateOrderGroup();
            }}
          >
            {" "}
            {/* {updateOrderGroupLoading && ( */}
            {confirmOrderGroupLoading && (
              <Spinner className="mr-2" size="sm" animation="border" />
            )}
            ຢືນຢັນການຊໍາລະ
          </Button>
          {(settingDataByShop?.settingByShopId?.logisticsCOD && isUseLogicstics === "IS_USE_LOGICSTIC") && (
            <Button onClick={() => {
              if (_.isEmpty(phone)) {
                return requestionFields({
                  text: "ກະລຸນາ ປ້ອນເບີໂທກ່ອນ!",
                })
              }
              if (_.isEmpty(address)) {
                return requestionFields({
                  text: "ກະລຸນາ ປ້ອນທີ່ຢູ່ເພື່ອຈັດສົ່ງ!",
                })
              }
              setIsShipMentPayType((preOpen) => ({ ...preOpen, isOpenCod: true }))
            }} style={{ background: COLOR_TOMATO, color: COLOR_WHITE, border: "none" }}>ເກັບປາຍທາງ (COD)</Button>
          )}
        </ButtonGroup>


      </div>
    </div>
  );
};

export default ShopInfoOrderConfirm;
